<template>
  <div class="customer">
    <div class="content">
      <div class="left">
        <img src="../assets/zy/hmap.png" alt />
        <div class="list">
          <!-- 德国 -->
          <div class="ningbo"></div>
          <!-- 奥地利 -->
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
          </div>
          <!-- 意大利 -->
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
          </div>
          <!-- 西班牙 -->
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
          </div>
          <!-- 英国 -->
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
          </div>
          <!-- 法国 -->
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
          </div>
          <!-- 瑞士 -->
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
          </div>
          <!-- 美国 -->
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
          </div>
          <!-- 加拿大 -->
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
          </div>
          <!-- 巴西 -->
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
          </div>
          <div class="ningbo">
            <div class="tq1"></div>
            <div class="tq2"></div>
            <div class="tq3"></div>
            <div class="text">
              <img src="../assets/zy/topLogo.png" alt />
              <div>
                <div class="txt">
                  <p  >CHINA NINGBO</p>
                  <p v-if="$i18n.locale=='zh-CN'">中国 宁波</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <p class="t1" >contact</p>
        <p class="t2" v-if="$i18n.locale=='zh-CN'" >联系达克</p>
        <div class="info">
          <p>
            <i class="iconfont icon-dianhua1"></i>
            +86-574-86597659
          </p>
          <p>
            <i class="iconfont icon-chuanzhen"></i>
            +86-574-86597600
          </p>
          <p>
            <i class="iconfont icon-youxiangyoujian"></i>
            david@dhk-intl.com
          </p>
          <p>
            <i class="iconfont icon-weizhi"></i>
            {{$t('home').customer.text0}} 315200
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "customer",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.customer {
  width: 100%;
  background-color: #333333;
  margin: 60px auto;
  margin-bottom: 0;
  animation-duration: 2s;
  padding: 100px 0;
  .content {
    width: 1440px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .left {
      width: 65%;
      position: relative;
      img {
        width: 100%;
        display: block;
        object-fit: cover;
      }
      .list {
        .point {
          position: absolute;
          width: 9.85%;
          padding-top: 9.85%;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          background-image: url(../assets/zy/point-bg.png);
          transform-origin: center;
          transform: scale(0.5);
          animation: pointAni 2s infinite;
          -webkit-animation: pointAni 2s infinite;
          p {
            color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 14px;
            opacity: 0.8;
          }
        }
        @keyframes pointAni {
          50% {
            transform: scale(1);
          }
          100% {
            transform: scale(0.5);
          }
        }

        .ningbo:nth-child(1) {
          left: 46%;
          top: 14%;
          display: none;
        }
        .ningbo:nth-child(2) {
          left: 60%;
          top: 26%;
        }
        .ningbo:nth-child(3) {
          left: 47%;
          top: 21%;
          display: none;
        }
        .ningbo:nth-child(4) {
          left: 50%;
          top: 25%;
        }
        .ningbo:nth-child(5) {
          left: 60%;
          top: 15%;
        }
        .ningbo:nth-child(6) {
          left: 43%;
          top: 17%;
          display: none;
        }
        .ningbo:nth-child(7) {
          left: 44%;
          top: 17%;
          display: none;
        }
        .ningbo:nth-child(8) {
          left: 54%;
          top: 78%;
        }
        .ningbo:nth-child(9) {
          left: 25%;
          top: 25%;
        }
        .ningbo:nth-child(10) {
          left: 35%;
          top: 65%;
        }
        .ningbo {
          position: absolute;
          top: 38.02%;
          left: 80.49%;
          &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 8px;
            height: 8px;
            background-color: #fff;
            border-radius: 50%;
          }
          .tq1 {
            position: absolute;
            top: -35px;
            left: -35px;
            width: 66px;
            height: 66px;
            // margin: -4px 0 0 -4px;
            border-radius: 50%;
            box-shadow: 0 0 4px rgba(255, 255, 255, 0.1), 0 0 10px rgba(255, 255, 255, 0.1) inset;
            border: 2px solid rgba(255, 255, 255, 0.1);
            // background-color: rgba(255, 255, 255, 0.2);
            animation: bianda 2.5s infinite linear;
          }
          .tq2 {
            position: absolute;
            top: -35px;
            left: -35px;
            width: 66px;
            height: 66px;
            // margin: -4px 0 0 -4px;
            border-radius: 50%;
            box-shadow: 0 0 4px rgba(255, 255, 255, 0.1), 0 0 10px rgba(255, 255, 255, 0.1) inset;
            border: 2px solid rgba(255, 255, 255, 0.1);
            // background-color: rgba(255, 255, 255, 0.1);
            animation: bianda2 2s infinite linear;
          }
          .tq3 {
            position: absolute;
            top: -35px;
            left: -35px;
            width: 66px;
            height: 66px;
            // margin: -4px 0 0 -4px;
            box-shadow: 0 0 4px rgba(255, 255, 255, 0.1), 0 0 10px rgba(255, 255, 255, 0.1) inset;
            border-radius: 50%;
            border: 2px solid rgba(255, 255, 255, 0.1);
            // background-color: rgba(255, 255, 255, 0.1);
            animation: bianda3 3s infinite linear;
          }
          .text {
            position: absolute;
            left: 29px;
            bottom: -24px;
            font-size: 12px;
            color: #fff;
            width: 100px;
            text-align: center;
            img {
            }
            .txt {
              p{
                color: white;
              }
            }
          }
        }
        @keyframes bianda {
          0% {
            transform: scale(0);
          }
          100% {
            transform: scale(1);
          }
        }
        @keyframes bianda2 {
          0% {
            transform: scale(0);
          }
          100% {
            transform: scale(1);
          }
        }
        @keyframes bianda3 {
          0% {
            transform: scale(0);
          }
          100% {
            transform: scale(1);
          }
        }
      }
    }
    .right {
      width: 30%;
      .t1 {
        font-family: "DINEngschriftStd";
        font-size: 50px;
        color: white;
        text-transform: uppercase;
      }
      .t2 {
        font-family: "SourceHanSansSC-Regular";
        font-size: 25px;
        color: white;
        padding: 30px 0;
        position: relative;
        &::after {
          content: "";
          display: inline-block;
          width: 47px;
          height: 5px;
          background: rgba(166, 129, 29, 1);
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
      .info {
        width: 100%;
        margin: 80px auto;
        p {
          margin-top: 30px;
          color: white;
          font-family: "it";
          display: flex;
          flex-direction: row;
          align-items: center;
          i {
            color: #a3a3a3;
            font-size: 25px;
            margin-right: 10px;
            transition: all 600ms;
            cursor: pointer;
            &:hover {
              color: white;
            }
          }
        }
      }
    }
  }
  @keyframes transition1 {
    0% {
      transform: translate(-100px, 100px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px, -100px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @media screen and (max-width: 1440px) {
    .content {
      width: 90%;
    }
  }
  @media screen and (max-width: 1000px) {
    padding: 50px 0;
    .content {
      flex-direction: column;
      .left{
        .list{
          .ningbo:nth-child(11){
            .text{
              left: -30px;
              bottom: -65px;
            }
          }
        }
      }
      .left,
      .right {
        width: 100%;
        margin-left: 0;
      }
      .right {
        margin-top: 30px;
        .t1 {
          font-size: 30px;
        }
        .info {
          margin: 30px auto;
          p {
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.left .swiper-pagination2 {
  display: none;
}
.left .swiper-pagination {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: static;
}
.left .swiper-pagination >>> .swiper-pagination-bullet {
  font-family: "SOURCEHANSANSCN-HEAVY";
  margin-top: 20px;
  width: 50px;
  color: #666666;
  height: 50px;
  transition: all 600ms;
  border-radius: 50%;
  display: flex;
  font-size: 18px;
  flex-direction: column;
  align-items: center;
  line-height: 50px;
  text-align: center;
  background-color: transparent;
  opacity: 1;
}
.left .swiper-pagination >>> .swiper-pagination-bullet:focus {
  outline: none !important;
}
.left .swiper-pagination >>> .swiper-pagination-bullet-active {
  background: rgba(0, 0, 0, 1);
  color: white;
}
@media screen and (max-width: 1000px) {
  .left .swiper-pagination {
    display: none;
  }
  .left .swiper-pagination2 {
    display: block;
  }
}
</style>
